'use client';

import { usePathname, useParams } from 'next/navigation';
import { getSeoUrl } from 'utils/links';

/**
 * Check if current path matches with current seoUrl + given path
 * @example
 * const isHomePage = usePathMatch('/');
 * const isCategoryPage = usePathMatch('/c/:category');
 * const isFilterCategoryPage = usePathMatch('/c/filter');
 */
export const usePathMatch = (path = '') => {
  const params = useParams();
  const pathname = usePathname();
  const normalizedPath = getSeoUrl(params, path)
    .replace(/:(\w+)/g, (_, param) => params[param] as string)
    .replace(/\/$/, '');

  return pathname === normalizedPath;
};
